import React, { Component } from "react";
import ApiConfig from "../../constants/ApiConfig";
import { connect } from "react-redux";
import { Nav, NavItem, NavbarToggler, NavbarBrand, NavLink } from "reactstrap";
import HeaderDropdownAction from "./HeaderDropdownAction";
import HeaderDropdownCms from "./HeaderDropdownCms";
import * as sessionService from "../../services/session";

import moment from "moment";
import "moment/locale/fr";

moment.locale("fr"); // 'fr'

const logo = `url(img/logo.png)`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cronInfos: null,
    };
  }

  componentWillMount() {
    this.load();
  }

  load() {

  }

  refresh() {
    window.location.reload();
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  }

  render() {
    const { cronInfos } = this.state;
    const { isAdmin, isTCP, isADV } = this.props;

    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarToggler
          className="d-md-down-none sidebar-minimizer h-100"
          onClick={this.sidebarToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarBrand href="#" style={{ backgroundImage: logo }}></NavbarBrand>

        <Nav className="ml-auto" navbar>
          <div className={"px-5"}>
            {isAdmin && <HeaderDropdownCms />}

          </div>

          {cronInfos && cronInfos[0] && (
            <a className="text-gray-200 d-md-down-none">
              Dernière MAJ:{" "}
              {moment(cronInfos[0].updated)
                .locale("fr")
                .format("dddd Do MMMM YYYY, HH:mm:ss")}{" "}
            </a>
          )}
          {/*<HeaderDropdownAccount />*/}
          <HeaderDropdownAction />
          <NavItem className="d-md-down-none">
            <NavLink href="javascript:void(0);" onClick={() => this.refresh()}>
              <i className="fp-refresh" />
            </NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink
              href={`${ApiConfig.helpAdmin}/index.html`}
              target={"_blank"}
            >
              <i className="fp-question" />
            </NavLink>
          </NavItem>
        </Nav>

        {/*
                <NavbarToggler className="d-md-down-none" onClick={this.asideToggle}>
                    <span className="icon-settings"></span>
                </NavbarToggler>*/}
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({});

module.exports = connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js